import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../../utils';
import { partnerApiPath } from '../../apiPath';
import { partnerHttpClient } from '../../httpClient';

const ProposeSeedingCuratorsRequestSchema = z
  .object({
    campaignId: z.union([z.string(), z.number()]),
    body: z.object({
      curatorIds: z.array(z.string()).min(1),
    }),
  })
  .describe('ProposeSeedingCuratorsRequestSchema');

export type ProposeSeedingCuratorsRequest = z.infer<typeof ProposeSeedingCuratorsRequestSchema>;

const ProposeSeedingCuratorsSuccessDataSchema = z
  .object({
    successCount: z.number().int().min(0),
  })
  .describe('ProposeSeedingCuratorsSuccessDataSchema');

const ProposeSeedingCuratorsResponseSchema = createApiResponseSchema(
  ProposeSeedingCuratorsSuccessDataSchema,
);

export type ProposeSeedingCuratorsResponse = z.infer<typeof ProposeSeedingCuratorsResponseSchema>;

export const PROPOSE_SEEDING_CURATORS_ERROR_CODE = {
  SNS_NOT_REGISTERED: 'CURATOR_SNS_NOT_REGISTERED',
  ALREADY_PROPOSED: 'CURATOR_ALREADY_PROPOSED',
  CAMPAIGN_NOT_ACTIVE: 'CAMPAIGN_NOT_ACTIVE',
} as const;

export type ProposeSeedingCuratorsErrorCode =
  (typeof PROPOSE_SEEDING_CURATORS_ERROR_CODE)[keyof typeof PROPOSE_SEEDING_CURATORS_ERROR_CODE];

export const ProposeSeedingCuratorsInvalidCuratorSchema = z.object({
  curatorId: z.string(),
  nickname: z.string(),
});
export type ProposeSeedingCuratorsInvalidCurator = z.infer<
  typeof ProposeSeedingCuratorsInvalidCuratorSchema
>;

export const ProposeSeedingCuratorsSnsFailDataSchema = z.object({
  invalidCurators: z.array(ProposeSeedingCuratorsInvalidCuratorSchema),
});
export type ProposeSeedingCuratorsSnsFailData = z.infer<
  typeof ProposeSeedingCuratorsSnsFailDataSchema
>;

export const ProposeSeedingCuratorsAlreadyProposedDataSchema = z.object({
  alreadyProposed: z.array(ProposeSeedingCuratorsInvalidCuratorSchema),
});
export type ProposeSeedingCuratorsAlreadyProposedData = z.infer<
  typeof ProposeSeedingCuratorsAlreadyProposedDataSchema
>;

export const proposeSeedingCurators = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(ProposeSeedingCuratorsRequestSchema),
    async (request: ProposeSeedingCuratorsRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.post<ProposeSeedingCuratorsResponse>(
          partnerApiPath.proposeSeedingCurators(request.campaignId),
          request.body,
        ),
      ),
    validateApiResponse(ProposeSeedingCuratorsResponseSchema),
  ),
);
